<template>
    <div class="wrapper-editor">
        <v-card class="pa-2" outlined>
            <div :class="[focusState ? 'editor editor-showEverybody' : 'editor']">
                <editor-content class="editor__content" :editor="editor"/>
            </div>
            <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }" class="mt-4" v-show="focusState">
                <div :class="[focusState ? 'menubar d-flex' : 'menubar']">
                    <v-btn
                        class="menubar__button ma-1 pa-0"
                        :class="{ 'is-active': isActive.bold() }"
                        @click="commands.bold"
                        type="button"
                        :color="color ? color : 'white'"
                        depressed
                        small
                    >
                        <v-icon>format_bold</v-icon>
                    </v-btn>
                    <v-btn
                        class="menubar__button ma-1 pa-0"
                        :class="{ 'is-active': isActive.italic() }"
                        @click="commands.italic"
                        :color="color ? color : 'white'"
                        depressed
                        small
                    >
                        <v-icon>format_italic</v-icon>
                    </v-btn>
                    <v-btn
                        class="menubar__button ma-1 pa-0"
                        :class="{ 'is-active': isActive.underline() }"
                        @click="commands.underline"
                        :color="color ? color : 'white'"
                        depressed
                        small
                    >
                        <v-icon>format_underline</v-icon>
                    </v-btn>
                    <v-btn
                        class="menubar__button ma-1 pa-0"
                        :class="{ 'is-active': isActive.strike() }"
                        @click="commands.strike"
                        :color="color ? color : 'white'"
                        depressed
                        small
                    >
                        <v-icon>strikethrough_s</v-icon>
                    </v-btn>
                    <v-btn
                        class="menubar__button ma-1 pa-0"
                        :class="{ 'is-active': isActive.bullet_list() }"
                        @click="commands.bullet_list"
                        :color="color ? color : 'white'"
                        depressed
                        small
                    >
                        <v-icon>format_list_bulleted</v-icon>
                    </v-btn>
                    <v-btn
                        class="menubar__button ma-1 pa-0"
                        :class="{ 'is-active': isActive.ordered_list() }"
                        @click="commands.ordered_list"
                        :color="color ? color : 'white'"
                        depressed
                        small
                    >
                        <v-icon>format_list_numbered</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="files"
                        class="menububble__button ma-1 pa-0"
                        :color="color ? color : 'white'"
                        depressed
                        small
                        for="file-input"
                    >
                        <label for="file-input">
                            <v-icon>attach_file</v-icon>
                        </label>
                        <input type="file" id="file-input" class="custom-file-input" @change="files" multiple>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="button"
                        class="ml-1 mr-3"
                        color="primary"
                        @click.native="saveInteraction"
                        :loading="btnDisable"
                    >
                        {{ $t('common.save') }}
                    </v-btn>
                </div>
            </editor-menu-bar>
        </v-card>
    </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
    BulletList,
    ListItem,
    OrderedList,
    Bold,
    Italic,
    Strike,
    Underline,
    Placeholder
} from 'tiptap-extensions'

export default {
    name: 'editor-text',
    components: {
        EditorContent,
        EditorMenuBar
    },
    props: ['value', 'button', 'files', 'color', 'background', 'focus'],
    data () {
        return {
            btnDisable: false,
            focusState: null,
            editor: null,
            content: '',
            editing: false
        }
    },
    mounted () {
        this.editor = new Editor({
            content: ``,
            extensions: [
                new BulletList(),
                new ListItem(),
                new OrderedList(),
                new Bold(),
                new Italic(),
                new Strike(),
                new Underline(),
                new Placeholder({
                    emptyEditorClass: 'is-editor-empty',
                    emptyNodeClass: 'is-empty',
                    emptyNodeText: this.$t('common.editorEmptyNodeText'),
                    showOnlyWhenEditable: true,
                    showOnlyCurrent: true
                })
            ],
            onFocus: ({ event, state, view }) => {
                this.focusState = true
            },
            onUpdate: ({ getHTML }) => {
                this.$emit('input', this.editor.getHTML())
            }
        })
        if (this.value !== undefined) {
            this.editor.setContent(this.value)
        }
    },
    beforeDestroy () {
        this.editor.destroy()
    },
    watch: {
        focus: function (val, oldVal) {
            this.focusState = val
        },
        focusState: function (val, oldVal) {
            this.$emit('update:focus', val)
        },
        value () {
            if (this.editing === false) {
                if (!this.value) {
                    this.editor.setContent('')
                } else {
                    this.editor.setContent(this.value)
                }
                this.editing = true
            }
        }
    },
    methods: {
        async saveInteraction () {
            this.btnDisable = true
            this.btnDisable = await this.button()
        }
    }
}
</script>

<style lang="scss">
.wrapper-editor{
    .editor{
        .editor__content{
            height: 100%;
        }

        width: 100%;
        line-height: 20px;
        overflow-y: scroll;
        max-height: 20px;

        .ProseMirror{
            height: 100%;
            outline-width: 0;

            p{
                margin: 0px
            }
        }

        p.is-editor-empty:first-child::before {
            content: attr(data-empty-text);
            float: left;
            color: #aaa;
            pointer-events: none;
            height: 100%;
            font-style: italic;
        }

        &-showEverybody{
            height: 100px;
            max-height: 100px;
        }
    }
    #file-input{
        display: none;
    }
    .menubar__button {
        &.is-active {
            &:before {
                opacity: 0.24;
            }
        }
    }
}
</style>
